import { useCallback, useState } from 'react';
export const useModalState = (isOpenInitially = false)=>{
    const [isOpen, setIsOpen] = useState(isOpenInitially);
    const close = useCallback(()=>setIsOpen(false), []);
    const open = useCallback(()=>setIsOpen(true), []);
    return [
        isOpen,
        close,
        open
    ];
};
